import { CookieOptions } from 'universal-cookie/Cookies';

import { AbsoluteUrl } from '../../shared/Url';

export interface ICookieOptionsProvider {
  getOptions(key: string): CookieOptions;
}

export class MainDomainCookieOptionProvider implements ICookieOptionsProvider {
  private hostName: string;

  constructor(baseUrl: string) {
    this.hostName = AbsoluteUrl.parse(baseUrl).hostname;
  }

  getOptions = (key: string): CookieOptions => {
    return {
      domain: this.getCookieDomain(),
    };
  };

  private getCookieDomain = () => {
    const isFlokkDomain = this.hostName.toLowerCase().endsWith('flokk.com');
    return isFlokkDomain ? '.flokk.com' : undefined;
  };
}
